/**
 * Shared accordion shell helpers.
 * Critical editor behavior: when rendered in Easyblocks editor mode,
 * accordion bodies stay visible and header clicks must not toggle collapse.
 */
export function isEasyblocksEditorMode(): boolean {
  return typeof document !== "undefined" && document.body.classList.contains("is-easyblocks-editor");
}

export function resolveAccordionStartOpen(value: unknown): boolean {
  return value === "true" || value === true;
}

export function resolveAccordionExpanded(isInEditor: boolean, isStartOpen: boolean): boolean {
  return isInEditor || isStartOpen;
}

export function getAccordionButtonClass(isInEditor: boolean, expanded: boolean): string {
  return ["accordion-button", isInEditor || expanded ? "" : "collapsed"].filter(Boolean).join(" ");
}

export function getAccordionItemClass(): string {
  return "accordion-item text-bg-white";
}

export function getAccordionCollapseBaseClass(isInEditor: boolean): string {
  return isInEditor ? "accordion-item__collapse-editor" : "accordion-collapse collapse";
}

export function getAccordionToggleButtonProps(isInEditor: boolean, collapseId: string): Record<string, string> {
  return isInEditor
    ? {}
    : {
        "data-bs-toggle": "collapse",
        "data-bs-target": `#${collapseId}`,
      };
}